// extracted by css-extract-rspack-plugin
var _1 = "_AY6CC2M2Cotg2Dz";
var _2 = "eeZJ1ZguTSsPn6_l";
var _3 = "KXuzcLr0DZUZ2Nd_";
export { _1 as "disabled", _2 as "inputStyle", _3 as "multiline" }
